import React, { useState, useEffect } from "react";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/database";
import { Context } from "../backend/context";
import crypto from "crypto";
import { Redirect } from "react-router";

export default function Settings() {
  const {
    api_key,
    binance_api_key,
    kucoin_api_key,
    telegram_id,
    email,
    nickName,
    isProUser,
    isProPlusUser,
    uid,
    isLoggedIn,
    telegram_notifications,
    user,
  } = React.useContext(Context);
  const [apiKey, setApiKey] = useState(api_key);
  const [binanceapiKey, setBinanceApiKey] = useState(
    binance_api_key ? binance_api_key : ""
  );
  const [kucoinapiKey, setKucoinApiKey] = useState(
    kucoin_api_key ? kucoin_api_key : ""
  );
  const [filled, setFilled] = useState(telegram_notifications.filled);
  const [pending, setPending] = useState(telegram_notifications.pending);
  const [cancelled, setCancelled] = useState(telegram_notifications.cancelled);
  const [insufficientFunds, setInsufficient] = useState(
    telegram_notifications.insufficientFunds !== undefined
      ? telegram_notifications.insufficientFunds
      : true
  );
  const [uploading, setUploading] = useState(false);
  const [apiSecret, setApiSecret] = useState("");
  const [binanceapiSecret, setBinanceApiSecret] = useState("");
  const [kucoinapiSecret, setKucoinApiSecret] = useState("");
  const [kucoinapiPassphrase, setKucoinApiPassphrase] = useState("");
  const [name, setName] = useState(
    nickName && nickName.length > 0
      ? nickName
      : uid
      ? uid.slice(0, 3).toUpperCase()
      : ""
  );
  const [isNameEditing, setNameEditing] = useState(false);
  const [isApiEditing, setApiEditing] = useState(
    api_key.length > 0 ? false : true
  );
  const [isBinanceApiEditing, setBinanceApiEditing] = useState(
    binance_api_key.length > 0 ? false : true
  );
  const [isKucoinApiEditing, setKucoinApiEditing] = useState(
    kucoin_api_key.length > 0 ? false : true
  );
  const publicKey =
    "-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAxEJXuxN8Gb+ZgTXbjqoL\nXvXhlB/VNos3yHGueyEsIGXydMAXPIIa8eTinznpSfRRsg+vHj4ggy+KhHZBnAdN\nXY17aQJGue6dbi0NKmDlK41EuUawV8nI1VxKkj6nwacSTs7CWioPzguS4kOz4B1p\nuUcUDxep48m2l9CWG5UNwMVx5z4T3KvDkCIEwRUEnJu1arEVsWPWl/KeyGO80NxX\nNGzR5z3j0BZEUmbVumAkauippc9KADPUfklxdJcIOGB3h5G7BEptsUKSijG2iK8u\noZ3xaPBbv+B7lxSZtxpVfzAc5BEAtUnVUbuVtDxlw6gzZqmQSkg9ktOTWhGUqv37\nSwIDAQAB\n-----END PUBLIC KEY-----\n";

  useEffect(() => {
    setName(nickName);
  }, [nickName]);
  useEffect(() => {
    setApiKey(api_key);
    setApiEditing(api_key.length > 0 ? false : true);
    // console.log(api_key);
  }, [api_key]);

  useEffect(() => {
    setUploading(true);
    firebase
      .database()
      .ref("/users/" + uid)
      .update({
        telegram_notifications: {
          filled: filled,
          pending: pending,
          cancelled: cancelled,
          insufficientFunds: insufficientFunds,
        },
      })
      .then((res) => {
        setUploading(false);
      })
      .catch((err) => {
        setUploading(false);
      });
  }, [filled, pending, cancelled, insufficientFunds, uid]);

  const updateNashApi = (e) => {
    e.preventDefault();
    const secretKey = crypto.randomBytes(16).toString("hex");
    const obj = encryptWithSecret(apiSecret, secretKey);
    const secret = encryptWithRSA(secretKey, publicKey);
    firebase
      .database()
      .ref("/users/" + uid)
      .update({
        api_key: apiKey,
        api_secret: { api_key_data: obj, secret_key: secret },
      })
      .then((res) => {
        setApiEditing(false);
      });
  };
  const updateBinanceApi = (e) => {
    e.preventDefault();
    const secretKey = crypto.randomBytes(16).toString("hex");
    const obj = encryptWithSecret(binanceapiSecret, secretKey);
    const secret = encryptWithRSA(secretKey, publicKey);
    firebase
      .database()
      .ref("/users/" + uid)
      .update({
        binance_api_key: binanceapiKey,
        binance_api_secret: { api_key_data: obj, secret_key: secret },
      })
      .then((res) => {
        setBinanceApiEditing(false);
      });
  };
  const updateKucoinApi = (e) => {
    e.preventDefault();
    const secretKey = crypto.randomBytes(16).toString("hex");
    const obj = encryptWithSecret(kucoinapiSecret, secretKey);
    const secret = encryptWithRSA(secretKey, publicKey);
    firebase
      .database()
      .ref("/users/" + uid)
      .update({
        kucoin_api_key: kucoinapiKey,
        kucoin_api_secret: { api_key_data: obj, secret_key: secret },
        kucoin_api_passphrase: kucoinapiPassphrase,
      })
      .then((res) => {
        setKucoinApiEditing(false);
      });
  };
  const handleDeactivateTelegram = () => {
    if (window.confirm("Do You Want To Deactivate Telegram Notifications ?")) {
      firebase
        .database()
        .ref("/users/" + uid)
        .update({
          telegram_id: "",
        });
    }
  };
  const handleActivateTelegram = () => {
    firebase
      .database()
      .ref("/telegramRequests/" + uid.slice(5, 15))
      .set({
        uid: uid,
        email: email,
      });
    var url = "https://telegram.me/dline_trading_bot?start=" + uid.slice(5, 15);
    window.open(url);
  };
  const encryptWithSecret = (text, secretKey) => {
    const iv = crypto.randomBytes(16);
    const cipher = crypto.createCipheriv("aes-256-ctr", secretKey, iv);

    const encrypted = Buffer.concat([cipher.update(text), cipher.final()]);

    return {
      iv: iv.toString("hex"),
      content: encrypted.toString("hex"),
    };
  };
  const encryptWithRSA = (msg, publicKey) => {
    var buffer = Buffer.from(msg);
    var encrypted = crypto.publicEncrypt(publicKey, buffer);
    return encrypted.toString("hex");
  };
  const changeName = () => {
    firebase
      .database()
      .ref("/users/" + uid)
      .update({
        nickName: name,
      })
      .catch((err) => {
        console.log(err);
      });
    setNameEditing(false);
  };

  return (
    <div className="py-5 container text-left badge-dark">
      {!isLoggedIn || !user ? <Redirect to="/" /> : null}
      <div className="row mt-3">
        <div className="col-12 h2">Settings</div>
      </div>
      <div className="row rounded-lg badge-dark border border-black p-2 mt-3">
        <div className="col-12">
          <div className="row ">
            <div className="col-3 col-sm-2 p-3 text-right">Email :</div>
            <div className="col-4 col-sm-4 p-3 text-left">{email}</div>

            {isProPlusUser ? (
              <div className="col-5 col-sm-4 p-3 text-right">
                <button className="btn btn-sm btn-info px-3 ">Pro+</button>
              </div>
            ) : isProUser ? (
              <div className="col-5 col-sm-4 p-3 text-right">
                <button className="btn btn-sm btn-info px-3 ">Pro</button>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="row mt-5">
            <div className="col-3 col-sm-2 py-3 text-right">Name :</div>
            <div className="col-5 col-sm-3 py-3 text-left">
              <input
                onChange={(e) => setName(e.target.value)}
                type="text"
                className="form-control"
                required
                value={name}
                disabled={!isNameEditing}
              />
            </div>
            {!isNameEditing ? (
              <div className="col-4 col-sm-2 text-left my-auto">
                <button
                  onClick={() => setNameEditing(true)}
                  className="btn px-3 btn-primary ml-3 w-75"
                >
                  Edit
                </button>
              </div>
            ) : (
              <div className="col-12 col-sm-5 text-left my-auto">
                <div className="row">
                  <div className="col-6 m-auto py-2">
                    <button
                      type="button"
                      className="btn px-3 btn-success ml-3 w-75"
                      disabled={name.length < 2}
                      onClick={() => changeName()}
                    >
                      Save
                    </button>
                  </div>

                  <div className="col-6 m-auto  py-2">
                    <button
                      className="btn px-3 btn-danger ml-3 w-75"
                      onClick={() => setNameEditing(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="row my-3">
        <div className="col-12 badge-dark rounded-lg border border-black pb-2">
          <div className="row">
            <div className="col-12 h4 py-3 ">Setup API Keys</div>
          </div>
          <div className="row">
            <div className="col-11 m-auto p-2">
              <form onSubmit={updateNashApi}>
                <div
                  className="row rounded-lg border border-black p-2 "
                  style={{ backgroundColor: "#292b2c" }}
                >
                  <div className="col-12 col-sm-10 pt-3 text-left m-auto">
                    <div className="row">
                      <div className="col-6 h4 mb-2 pb-3 ">Nash</div>
                      <div className="col-6 text-right">
                        <a
                          className="btn btn-sm btn-secondary"
                          target="_blank"
                          href="https://app.nash.io/create-account?code=2ty1Z4"
                        >
                          Create Nash Account
                        </a>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label">
                        API Key :
                      </label>
                      <div className="col-sm-8">
                        <input
                          onChange={(e) => setApiKey(e.target.value)}
                          type="text"
                          className="form-control"
                          required
                          value={apiKey}
                          disabled={!isApiEditing}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label">
                        API Secret :
                      </label>
                      <div className="col-sm-8">
                        <input
                          onChange={(e) => setApiSecret(e.target.value)}
                          type={isApiEditing ? "text" : "password"}
                          className="form-control"
                          required
                          value={isApiEditing ? apiSecret : "###############"}
                          disabled={!isApiEditing}
                        />
                      </div>
                    </div>
                  </div>
                  {!isApiEditing ? (
                    <div className="col-8 col-sm-2 m-auto w-100">
                      <button
                        onClick={() => setApiEditing(true)}
                        className="btn px-3 btn-primary ml-3 w-75"
                      >
                        Edit
                      </button>
                    </div>
                  ) : (
                    <div className="col-12 col-sm-2 m-auto">
                      <div className="row">
                        <div className="col-6 col-sm-12 m-auto py-2">
                          <button
                            type="submit"
                            className="btn px-3 btn-success ml-3 w-75"
                          >
                            Save
                          </button>
                        </div>

                        <div className="col-6 col-sm-12 m-auto py-2 ">
                          <button
                            className="btn px-3 btn-danger ml-3 w-75"
                            disabled={api_key.length < 1}
                            onClick={() => setApiEditing(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>

          <div className="row">
            <div className="col-11 m-auto p-2">
              <form onSubmit={updateBinanceApi}>
                <div
                  className="row rounded-lg border border-black p-2 mt-3"
                  style={{ backgroundColor: "#292b2c" }}
                >
                  <div className="col-12  col-sm-10 pt-3 text-left">
                    <div className="row">
                      <div className="col-6 h4 mb-2 pb-3 ">Binance </div>
                      <div className="col-6 text-right">
                        <a
                          className="btn btn-sm btn-secondary"
                          target="_blank"
                          href="https://www.binance.com/en/register?ref=TR1N6ZYI"
                        >
                          Create Binance Account
                        </a>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label">
                        API Key :
                      </label>
                      <div className="col-sm-8">
                        <input
                          onChange={(e) => setBinanceApiKey(e.target.value)}
                          type="text"
                          className="form-control"
                          required
                          value={binanceapiKey}
                          disabled={!isBinanceApiEditing}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label">
                        API Secret :
                      </label>
                      <div className="col-sm-8">
                        <input
                          onChange={(e) => setBinanceApiSecret(e.target.value)}
                          type={isBinanceApiEditing ? "text" : "password"}
                          className="form-control"
                          required
                          value={
                            isBinanceApiEditing
                              ? binanceapiSecret
                              : "###############"
                          }
                          disabled={!isBinanceApiEditing}
                        />
                      </div>
                    </div>
                  </div>
                  {!isBinanceApiEditing ? (
                    <div className="col-8 col-sm-2 m-auto w-100">
                      <button
                        onClick={() => setBinanceApiEditing(true)}
                        className="btn px-3 btn-primary ml-3 w-75"
                      >
                        Edit
                      </button>
                    </div>
                  ) : (
                    <div className="col-12 col-sm-2 m-auto">
                      <div className="row">
                        <div className="col-6 col-sm-12 m-auto py-2">
                          <button
                            type="submit"
                            className="btn px-3 btn-success ml-3 w-75"
                          >
                            Save
                          </button>
                        </div>

                        <div className="col-6 col-sm-12 m-auto  py-2">
                          <button
                            className="btn px-3 btn-danger ml-3 w-75"
                            disabled={binance_api_key.length < 1}
                            onClick={() => setBinanceApiEditing(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>

          <div className="row">
            <div className="col-11 m-auto p-2">
              <form onSubmit={updateKucoinApi}>
                <div
                  className="row rounded-lg border border-black p-2 mt-3"
                  style={{ backgroundColor: "#292b2c" }}
                >
                  <div className="col-12  col-sm-10 pt-3 text-left">
                    <div className="row">
                      <div className="col-6 h4 mb-2 pb-3 ">Kucoin </div>
                      <div className="col-6 text-right">
                        <a
                          className="btn btn-sm btn-secondary"
                          target="_blank"
                          href="https://www.kucoin.com/ucenter/signup?rcode=wwf6ds"
                        >
                          Create Kucoin Account
                        </a>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label">
                        API Key :
                      </label>
                      <div className="col-sm-8">
                        <input
                          onChange={(e) => setKucoinApiKey(e.target.value)}
                          type="text"
                          className="form-control"
                          required
                          value={kucoinapiKey}
                          disabled={!isKucoinApiEditing}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label">
                        API Secret :
                      </label>
                      <div className="col-sm-8">
                        <input
                          onChange={(e) => setKucoinApiSecret(e.target.value)}
                          type={isKucoinApiEditing ? "text" : "password"}
                          className="form-control"
                          required
                          value={
                            isKucoinApiEditing
                              ? kucoinapiSecret
                              : "###############"
                          }
                          disabled={!isKucoinApiEditing}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label">
                        API Passphrase :
                      </label>
                      <div className="col-sm-8">
                        <input
                          onChange={(e) =>
                            setKucoinApiPassphrase(e.target.value)
                          }
                          type={isKucoinApiEditing ? "text" : "password"}
                          className="form-control"
                          required
                          value={
                            isKucoinApiEditing
                              ? kucoinapiPassphrase
                              : "###############"
                          }
                          disabled={!isKucoinApiEditing}
                        />
                      </div>
                    </div>
                  </div>
                  {!isKucoinApiEditing ? (
                    <div className="col-8 col-sm-2 m-auto w-100">
                      <button
                        onClick={() => setKucoinApiEditing(true)}
                        className="btn px-3 btn-primary ml-3 w-75"
                      >
                        Edit
                      </button>
                    </div>
                  ) : (
                    <div className="col-12 col-sm-2 m-auto">
                      <div className="row">
                        <div className="col-6 col-sm-12 m-auto py-2">
                          <button
                            type="submit"
                            className="btn px-3 btn-success ml-3 w-75"
                          >
                            Save
                          </button>
                        </div>

                        <div className="col-6 col-sm-12 m-auto  py-2">
                          <button
                            className="btn px-3 btn-danger ml-3 w-75"
                            disabled={kucoin_api_key.length < 1}
                            onClick={() => setKucoinApiEditing(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="row rounded-lg badge-dark border border-black p-2 mt-3">
        <div className="col-12">
          <div className="row">
            <div className="col-12 h4 mb-2 ">Telegram bot setting</div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-7 py-2 text-left m-auto">
              <div className="form-check">
                <input
                  disabled={uploading}
                  type="checkbox"
                  className="form-check-input"
                  id="Filled"
                  checked={filled}
                  onChange={(e) => {
                    setFilled(e.target.checked);
                  }}
                />
                <label className="form-check-label" htmlFor="Filled">
                  Filled Orders
                </label>
              </div>
              <div className="form-check">
                <input
                  disabled={uploading}
                  type="checkbox"
                  className="form-check-input"
                  id="Pending"
                  checked={pending}
                  onChange={(e) => {
                    setPending(e.target.checked);
                  }}
                />
                <label className="form-check-label" htmlFor="Pending">
                  Pending Orders
                </label>
              </div>
              <div className="form-check">
                <input
                  disabled={uploading}
                  type="checkbox"
                  className="form-check-input"
                  id="Cancelled"
                  checked={cancelled}
                  onChange={(e) => {
                    setCancelled(e.target.checked);
                  }}
                />
                <label className="form-check-label" htmlFor="Cancelled">
                  Cancelled Orders
                </label>
              </div>
              <div className="form-check">
                <input
                  disabled={uploading}
                  type="checkbox"
                  className="form-check-input"
                  id="Insufficient"
                  checked={insufficientFunds}
                  onChange={(e) => {
                    setInsufficient(e.target.checked);
                  }}
                />
                <label className="form-check-label" htmlFor="Insufficient">
                  Insufficient Funds
                </label>
              </div>
            </div>
            <div className="col-sm-4 col-5 m-auto">
              {telegram_id > 0 ? (
                <button
                  onClick={handleDeactivateTelegram}
                  className="btn px-3 btn-danger m-auto"
                >
                  Deactivate
                </button>
              ) : (
                <button
                  onClick={handleActivateTelegram}
                  className="btn px-3 btn-primary m-auto"
                >
                  Activate
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
